import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const alertTicketDetailTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      wrapper: {
        background: theme.color.surface[1],
      },
      tag: {
        background: theme.color.surface[0],
      },
      text: {
        primary: theme.color.text.core['-primary'],
        secondary: theme.color.text.core['-secondary'],
        tertiary: theme.color.text.core['-tertiary'],
        critical: theme.color.dataVis.core['critical-1'],
      },
      border: {
        tertiary: theme.color.text.core['-tertiary'],
        selected: theme.color.focus[1],
      },
    },
  ]),
);
